import productSuggest from 'components/product/product-suggest.vue';
import productTopnew from 'components/product/product-topnew.vue';
import videoModal from 'components/video-modal.vue';

require('@sweetwater/lazyloader/vue-directive');

Vue.component('product-suggest', productSuggest);
Vue.component('product-topnew', productTopnew);
Vue.component('video-modal', videoModal);

new Vue({
    el: '#homepage-wrapper',
    methods: {
        loadComponent(componentName, channelName, args = {}) {
            Component.load(componentName).created(() => {
                this.relay(channelName, args);
            });
        },
        relay(channelName, args = {}) {
            events.relay({
                name: channelName,
                args: Object.assign({ status: true }, args),
            });
        },
        showVideoModal() {
            this.loadComponent(
                'videoModal',
                'videoModalShow',
            );
        },
    },
});

// Promo tile logging
const promoTiles = {
    impressionsToSend: [],
    sendAt: 0,
    processImpressions(processNow) {
        if (!promoTiles.impressionsToSend.length) {
            return;
        }
        if (!processNow) {
            const diff = promoTiles.sendAt - Date.now();
            if (diff > 0) {
                setTimeout(promoTiles.processImpressions, diff);
                return;
            }
        }
        const tileIds = promoTiles.impressionsToSend.slice(0);
        promoTiles.impressionsToSend = [];

        axios.get('/mrt.php', {
            RPC: '1',
            type: 'pp_track',
            delivery: 'home',
            action: 'impression',
            tile_id: tileIds,
        });
    },
    processClick() {
        const id = this.getAttribute('data-id');
        const pos = this.getAttribute('data-pos');

        axios.get('/mrt.php', {
            RPC: '1',
            type: 'pp_track',
            delivery: 'home',
            action: 'click',
            tile_id: id,
            pos,
        });
    },
};

const tiles = document.getElementsByClassName('candy-tile');
if (tiles.length) {
    [...tiles].forEach((tile) => {
        tile.addEventListener('click', promoTiles.processClick);
    });

    // Tile impressions used to piggyback on LazyLoader's 'show' callback.
    // Now that these images load natively there is no such callback, so the
    // beacon needs its own observer. rootMargin/threshold match what the
    // library used so impression volume is unchanged.
    const tileImages = document.querySelectorAll('.candy-tile img');
    if (tileImages.length) {
        const queueImpression = (img) => {
            const tileId = img.getAttribute('data-id');
            promoTiles.impressionsToSend.push(tileId);
            promoTiles.sendAt = Date.now() + 1000;
            promoTiles.processImpressions();
        };

        if ('IntersectionObserver' in window) {
            const impressionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting && entry.intersectionRatio <= 0) {
                        return;
                    }
                    // One-shot, matching the library's unobserve-on-load.
                    impressionObserver.unobserve(entry.target);
                    queueImpression(entry.target);
                });
            }, { rootMargin: '200px', threshold: [0] });

            [...tileImages].forEach(img => impressionObserver.observe(img));
        } else {
            [...tileImages].forEach(queueImpression);
        }
    }
}

// Picture shim
if (!Modernizr.picture) {
    document.createElement('picture');
    // eslint-disable-next-line global-require
    require(['picturefill']);
}

// Generic Sales Engineer Block Carousel
const seSlides = document.querySelectorAll('.se-g--slide');

if(seSlides && seSlides.length > 0){
    seSlides[1].setAttribute('id','se-g--slide--current');
    let i = -1;
    setInterval(function(){
        let slideQty = seSlides.length - 1,
            slideCurrent = document.getElementById('se-g--slide--current');
            i++;
        if(i > slideQty) {i = 0;}
        if(slideCurrent){slideCurrent.removeAttribute('id');}
        seSlides[i].setAttribute('id','se-g--slide--current');
    }, 5000);
}
